import 'css-chunksrc/client/common/quickAllocationMenu/resource/styles.scss';export default {
  "user": "_user_ycpjx_1",
  "avatar": "_avatar_ycpjx_13",
  "name": "_name_ycpjx_23",
  "title": "_title_ycpjx_29"
};